export default __webpack_public_path__ + "static/media/benefit_12@3x.48f735b5.png";